import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  Source,
  SourceValues,
  TransportationMode,
  TransportationModeValues,
  ValuesTeamMobility,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionTeamMobilityDto } from './dto.type';

export class QuestionTeamMobilityMapper {
  static dtoToEntity(
    dto: QuestionTeamMobilityDto,
  ): ImpactCo2Answer<ValuesTeamMobility> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'TEAM_MOBILITY',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        transportationMode: validateValueInType<TransportationMode>(
          dto.transportationMode,
          TransportationModeValues,
        ),
        numberOfDays: Number.parseFloat(dto.numberOfDays.toString()),
        passengerCount: Number.parseFloat(dto.passengerCount.toString()),
        travelDistance: Number.parseFloat(dto.travelDistance.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesTeamMobility>,
    projectId: number,
  ): Omit<QuestionTeamMobilityDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      transportationMode: answer.values.transportationMode,
      numberOfDays: answer.values.numberOfDays,
      passengerCount: answer.values.passengerCount,
      travelDistance: answer.values.travelDistance,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
